import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PasswordStrengthService {
  calculateStrength(password: string): number {
    if (!password) {
      return 0;
    }

    let strength = 0;
    // Mindestlänge 10 Zeichen
    if (password.length >= 10) {
      strength++;
    }
    // Großbuchstaben
    if (/[A-Z]/.test(password)) {
      strength++;
    }
    // Kleinbuchstaben
    if (/[a-z]/.test(password)) {
      strength++;
    }
    // Zahlen
    if (/[0-9]/.test(password)) {
      strength++;
    }
    // Sonderzeichen
    if (/[^a-zA-Z0-9]/.test(password)) {
      strength++;
    }

    return strength;
  }

  isPasswordStrong(password: string): boolean {
    return this.calculateStrength(password) === 5;
  }

  generatePassword(length: number = 10): string {
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const special = '!@#$%^&*()_-+=';
    const allChars = lowercase + uppercase + numbers + special;

    // Mindestens 1 Zeichen aus jeder Kategorie
    let password = '';
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += special[Math.floor(Math.random() * special.length)];

    // Auffüllen mit random characters
    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    // Mischen
    password = password
      .split('')
      .sort(() => Math.random() - 0.5)
      .join('');

    return password;
  }
}
